@if (options) {
  <app-modal-header
    [title]="options.header"
    [close]="cancel"
    [hideClose]="options.required || false">
  </app-modal-header>
}

@if (options) {
  <div class="content-wrapper">
    <div class="special-scroller">
      @if (options.subHeader) {
        <div class="sub-header">
          {{ options.subHeader }}
        </div>
      }
      @if (options.message) {
        <div class="message" [innerHTML]="options.message"></div>
      }
      @for (control of emailFormArray.controls; track $index; ) {
        <div class="form-control-container" [ngClass]="{
        'custom-input--invalid': control.invalid && (control.dirty),
        'custom-input--valid': control.valid && (control.dirty)
      }">
          <input
            class="custom-input"
            placeholder=" "
            [formControl]="getEmailFormControl($index)">
          @if (options.inputLabel) {
            <label>{{ options.inputLabel }}</label>
          }
          @if (control.invalid && control.dirty) {
            <span class="input-error">Enter a valid email address</span>
          }
        </div>
      }
      <div class="add-n-remove">
        <span class="icon-button" (click)="addEmail()">
          <app-display-icon
            [icon]="icons.plus"
            [colour]="iconColourEnum.secondary">
          </app-display-icon>
        </span>
        @if (emailFormArray.length !== 1) {
          <span class="icon-button" (click)="removeEmail()">
            <app-display-icon
              [icon]="icons.close"
              [colour]="iconColourEnum.red">
            </app-display-icon>
          </span>
        }
      </div>
    </div>
    <app-shared-modal-footer>
      @if (!options.required) {
        <app-shared-button
          (buttonClicked)="cancel()"
          [fill]="false"
          [colour]="'primary'">
          {{ options.cancelText }}
        </app-shared-button>
      }
      <app-shared-button
        (buttonClicked)="submit()"
        [disabled]="emailForm.invalid"
        [fill]="true"
        [colour]="'secondary'">
        {{ options.submitText }}
      </app-shared-button>
    </app-shared-modal-footer>
  </div>
}
